export const formatText = (value) => {
  if (typeof value === "string") {
    const replacedValue = value.replace(",", ".");
    const numberValue = parseFloat(replacedValue);
    return isNaN(numberValue) ? value : numberValue;
  }

  if (typeof value === "number") {
    return value;
  }

  return value;
};

export function getFormattedDecimalNumber(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "string") {
    const parsedValue = parseFloat(value.replace(",", "."));
    if (Number.isNaN(parsedValue)) {
      return value;
    }
    return formatGermanNumber(value);
  }

  if (typeof value === "number") {
    return formatGermanNumber(value.toString());
  }

  return null;
}

function formatGermanNumber(value) {
  const [integerPart, decimalPart] = value.split(/[.,]/);

  // Format only the integer part
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // If there's a decimal part, skip it and return the formatted integer part only
  return formattedInteger;
}

export function formatToTwoDecimals(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const num = parseFloat(value);

  if (isNaN(num)) {
    return null;
  }

  return num.toFixed(2);
}

/**
 * Format number with commas as thousands separator
 * Used for input fields to display numbers in readable format
 *
 * @param {string|number} value - The value to format
 * @returns {string} Formatted number with commas (e.g., "1,000" or "1,000.50")
 *
 * @example
 * formatNumberWithCommas("1000") // "1,000"
 * formatNumberWithCommas("1000000") // "1,000,000"
 * formatNumberWithCommas("1000.50") // "1,000.50"
 */
export function formatNumberWithCommas(value) {
  if (!value) return "";
  // Remove all non-numeric characters except decimal point
  const numericValue = value.toString().replace(/[^\d.]/g, "");
  // Split by decimal point
  const parts = numericValue.split(".");
  // Format the integer part with commas
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // Return formatted value (limit to 2 decimal places)
  return parts.length > 1 ? `${parts[0]}.${parts[1].slice(0, 2)}` : parts[0];
}

/**
 * Parse formatted number back to plain number string
 * Removes commas to get the actual numeric value
 *
 * @param {string|number} value - The formatted value to parse
 * @returns {string} Plain number string without commas
 *
 * @example
 * parseFormattedNumber("1,000") // "1000"
 * parseFormattedNumber("1,000.50") // "1000.50"
 */
export function parseFormattedNumber(value) {
  if (!value) return "";
  // Remove commas and return plain number string
  return value.toString().replace(/,/g, "");
}

/**
 * Validate if input contains only numbers, commas, and decimal points
 * Used for real-time input validation
 *
 * @param {string} value - The value to validate
 * @returns {boolean} True if valid, false otherwise
 *
 * @example
 * isValidNumberInput("1,000") // true
 * isValidNumberInput("1000.50") // true
 * isValidNumberInput("abc123") // false
 */
export function isValidNumberInput(value) {
  return /^[\d,\.]*$/.test(value);
}
